// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/feature/activity/activity.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_core_common } from "../../core/common_pb";
import { file_proto_model_entity_place } from "../../entity/place_pb";

/**
 * Describes the file proto/model/feature/activity/activity.proto.
 */
export const file_proto_model_feature_activity_activity = /*@__PURE__*/
  fileDesc("Citwcm90by9tb2RlbC9mZWF0dXJlL2FjdGl2aXR5L2FjdGl2aXR5LnByb3RvEgZjYXJtZW4iwwEKCEFjdGl2aXR5EgwKBG5hbWUYASABKAkSJQoKcGFydHlfc2l6ZRgCIAEoCzIRLmNhcm1lbi5QYXJ0eVNpemUSPQoXYXBwcm94aW1hdGVfdGltZV9vZl9kYXkYAyABKA4yHC5jYXJtZW4uQXBwcm94aW1hdGVUaW1lT2ZEYXkSJQoKY3Jvd2Rfc2l6ZRgEIAEoDjIRLmNhcm1lbi5Dcm93ZFNpemUSHAoFdmVudWUYBSABKAsyDS5jYXJtZW4uUGxhY2UquwEKEVBhcnR5U2l6ZUNhdGVnb3J5EiMKH1BBUlRZX1NJWkVfQ0FURUdPUllfVU5TUEVDSUZJRUQQABIiCh5QQVJUWV9TSVpFX0NBVEVHT1JZX0lORElWSURVQUwQARIeChpQQVJUWV9TSVpFX0NBVEVHT1JZX0NPVVBMRRACEh4KGlBBUlRZX1NJWkVfQ0FURUdPUllfRkFNSUxZEAMSHQoZUEFSVFlfU0laRV9DQVRFR09SWV9HUk9VUBAEKmcKCUNyb3dkU2l6ZRIaChZDUk9XRF9TSVpFX1VOU1BFQ0lGSUVEEAASEgoOQ1JPV0RfU0laRV9MT1cQARIVChFDUk9XRF9TSVpFX01FRElVTRACEhMKD0NST1dEX1NJWkVfSElHSBADQjlaN2dpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsL2ZlYXR1cmUvYWN0aXZpdHliBnByb3RvMw", [file_proto_model_core_common, file_proto_model_entity_place]);

/**
 * Describes the message carmen.Activity.
 * Use `create(ActivitySchema)` to create a new message.
 */
export const ActivitySchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_activity_activity, 0);

/**
 * Describes the enum carmen.PartySizeCategory.
 */
export const PartySizeCategorySchema = /*@__PURE__*/
  enumDesc(file_proto_model_feature_activity_activity, 0);

/**
 * Categorization of party sizes for filtering and recommendations
 *
 * @generated from enum carmen.PartySizeCategory
 */
export const PartySizeCategory = /*@__PURE__*/
  tsEnum(PartySizeCategorySchema);

/**
 * Describes the enum carmen.CrowdSize.
 */
export const CrowdSizeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_feature_activity_activity, 1);

/**
 * @generated from enum carmen.CrowdSize
 */
export const CrowdSize = /*@__PURE__*/
  tsEnum(CrowdSizeSchema);

